/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/authRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/authRequestClient.ts'

import type {
    GetCoreApiV1Useraccess401,
    GetCoreApiV1Useraccess403,
    GetCoreApiV1UseraccessQueryResponse,
} from '../../types/GetCoreApiV1Useraccess.ts'

export const getCoreApiV1UseraccessQueryKey = () => [{ url: '/core/api/v1/useraccess' }] as const

export type GetCoreApiV1UseraccessQueryKey = ReturnType<typeof getCoreApiV1UseraccessQueryKey>

/**
 * {@link /core/api/v1/useraccess}
 */
export async function getCoreApiV1Useraccess(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<
        GetCoreApiV1UseraccessQueryResponse,
        ResponseErrorConfig<GetCoreApiV1Useraccess401 | GetCoreApiV1Useraccess403>,
        unknown
    >({ method: 'GET', url: `/core/api/v1/useraccess`, ...requestConfig })
    return res
}

export function getCoreApiV1UseraccessQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getCoreApiV1UseraccessQueryKey()
    return queryOptions<
        ResponseConfig<GetCoreApiV1UseraccessQueryResponse>,
        ResponseErrorConfig<GetCoreApiV1Useraccess401 | GetCoreApiV1Useraccess403>,
        ResponseConfig<GetCoreApiV1UseraccessQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getCoreApiV1Useraccess(config)
        },
    })
}

/**
 * {@link /core/api/v1/useraccess}
 */
export function useGetCoreApiV1Useraccess<
    TData = ResponseConfig<GetCoreApiV1UseraccessQueryResponse>,
    TQueryData = ResponseConfig<GetCoreApiV1UseraccessQueryResponse>,
    TQueryKey extends QueryKey = GetCoreApiV1UseraccessQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetCoreApiV1UseraccessQueryResponse>,
                ResponseErrorConfig<GetCoreApiV1Useraccess401 | GetCoreApiV1Useraccess403>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getCoreApiV1UseraccessQueryKey()

    const query = useQuery(
        {
            ...getCoreApiV1UseraccessQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<
        TData,
        ResponseErrorConfig<GetCoreApiV1Useraccess401 | GetCoreApiV1Useraccess403>
    > & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
